import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/latestNews.css";

interface NewsItem {
  id: number;
  title: string;
  short_description: string;
  full_description: string;
  image: string;
  link: string;
  publish_date: string;
  sort_order: number;
  status: "active" | "inactive";
}

const API_URL =
  import.meta.env.VITE_LYRAZONE_BASE_URL || "http://localhost:5000/api";
const IMAGE_BASE_URL =
  import.meta.env.VITE_LYRAZONE_IMAGE_URL || "http://localhost:5000/uploads";

const LatestNews: React.FC = () => {
  const [news, setNews] = useState<NewsItem[]>([]);

  useEffect(() => {
    fetchLatestNews();
  }, []);

  const fetchLatestNews = async () => {
    try {
      const response = await axios.get(`${API_URL}/admin/latest-news/website`);
      const data = Array.isArray(response.data?.data) ? response.data.data : [];
      setNews(data);
    } catch (error) {
      console.error("Error fetching latest news:", error);
      setNews([]);
    }
  };

  const getImageUrl = (image?: string) => {
    if (!image) return "";
    if (image.startsWith("http://") || image.startsWith("https://"))
      return image;
    return `${IMAGE_BASE_URL}/uploads/latestnews/${image}`;
  };

  return (
    <section id="latest-news" className="latest-news-section">
      <div className="container">
        <div className="latest-news-top">
          <div className="latest-news-top-left">
            <h2 className="latest-news-title">Latest News</h2>
            <span className="latest-news-underline"></span>
            <a href="/latest-news" className="latest-news-more-btn">
              See More
            </a>
          </div>

          {news.length > 0 ? (
            <div className="latest-news-grid">
              {news.map((item) => (
                <div className="latest-news-card" key={item.id}>
                  {item.image && (
                    <div className="latest-news-card-image-wrap">
                      <img
                        src={getImageUrl(item.image)}
                        alt={item.title}
                        className="latest-news-card-image"
                      />
                    </div>
                  )}

                  <div className="latest-news-card-body">
                    <h4 className="latest-news-card-title">{item.title}</h4>

                    <p className="latest-news-card-desc">
                      {item.short_description}
                    </p>

                    {item.link && (
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="latest-news-card-link"
                      >
                        Read More
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="latest-news-empty">No latest news available.</div>
          )}
        </div>
      </div>
    </section>
  );
};

export default LatestNews;
